import { openCalendlyPopup } from "@/lib/calendly";
import { ArrowUpRight } from "lucide-react";

/**
 * A drop-in replacement for a Link/button that opens the Calendly popup widget.
 * Preserves the existing btn-cf / btn-cf-ghost styling by accepting className + children.
 */
export default function BookButton({
  className = "btn-cf",
  children = "Book a Free Career Call",
  withArrow = true,
  "data-testid": testId,
  ...rest
}) {
  return (
    <button
      type="button"
      onClick={openCalendlyPopup}
      data-testid={testId}
      className={className}
      {...rest}
    >
      {children}
      {withArrow && <ArrowUpRight size={14} />}
    </button>
  );
}
